export * from './get-featured-ad-list';
